import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, PlugZapIcon } from 'lucide-react';
import { business, processSteps } from '../../data/site';
const ease = [0.23, 1, 0.32, 1] as const;
export function ProcessSection() {
  return <section aria-labelledby="process-title" className="w-full border-t border-white/10 bg-ink-2 text-white" data-id="element-85" data-mp="bt1qifx2ykbf">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-86" data-mp="7vm28n0x30ma">
        <div className="grid gap-6 lg:grid-cols-12" data-id="element-87" data-mp="2vrc4loyuf2a">
          <h2 id="process-title" className="font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-6xl lg:col-span-6" data-id="element-88" data-mp="3u941o45r995r">
            Vous ne bougez pas. <span className="text-sky" data-id="element-89" data-mp="3pa0wmjprz2xs">Je viens à vous.</span>
          </h2>
          <p className="max-w-md self-end leading-relaxed text-fog lg:col-span-5 lg:col-start-8" data-id="element-90" data-mp="3kbzfi4bwtdoy">
            Du premier appel à la remise des clés, une prestation simple, ponctuelle et discrète.
          </p>
        </div>

        <div className="relative mt-16" data-id="element-91" data-mp="3bars4haxlx9n">
        <div className="absolute left-0 right-0 top-5 hidden h-px bg-white/10 lg:block" aria-hidden="true" data-id="element-92" data-mp="3odf9eqiosmsu" />
        <ol className="relative grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-93" data-mp="3t4f8o2fa3gyi">
          {processSteps.map((step, i) => <motion.li key={step.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.3,
            delay: i * 0.06,
            ease
          }} className="relative" data-id="element-94" data-mp="3fdsacbdfjt2y" data-mpi={i}>
              <span className="relative grid h-10 w-10 place-items-center rounded-full bg-lime font-display text-base font-bold text-ink" data-id="element-95" data-mp="fv9cw425rb1d">
                {i + 1}
              </span>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-tight" data-id="element-96" data-mp="6v4903w6aury">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-fog" data-id="element-97" data-mp="2mm8m2d1z7ou3">{step.text}</p>
            </motion.li>)}
        </ol>
        </div>

        <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 md:grid-cols-2" data-id="element-98" data-mp="x6elxcsef7wr">
          <div className="flex gap-4 bg-ink-2 p-6" data-id="element-99" data-mp="s7bj7yzw5dry">
            <PlugZapIcon className="h-5 w-5 shrink-0 text-lime" aria-hidden="true" data-id="element-100" data-mp="s9xnnprhjd5y" />
            <div data-id="element-101" data-mp="nf1s4fn1i7o3">
              <h3 className="font-semibold" data-id="element-102" data-mp="neif9dc8y9gx">Une prise électrique, c'est tout</h3>
              <p className="mt-1 text-sm text-fog" data-id="element-103" data-mp="jd6vhog20ign">L'accès à une prise fonctionnelle sur place est nécessaire pour réaliser la prestation.</p>
            </div>
          </div>
          <div className="flex gap-4 bg-ink-2 p-6" data-id="element-104" data-mp="9gc03ef2uy6l">
            <CreditCardIcon className="h-5 w-5 shrink-0 text-lime" aria-hidden="true" data-id="element-105" data-mp="4hqwd50m9wde" />
            <div data-id="element-106" data-mp="4jttsa43mrs5">
              <h3 className="font-semibold" data-id="element-107" data-mp="goxipam3mby">Paiements acceptés</h3>
              <p className="mt-1 text-sm text-fog" data-id="element-108" data-mp="ii64a4scgml">{business.payments.join(' · ')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}